import ProductSettingsTab from "../ProductSettingsTab";
import {
  useLazyGetDealerRolesFirmSyncQuery,
  useUpdateDealerRolesFirmSyncMutation,
} from "../../../../store/dealerRoles/firmApi";

export default function DealerRolesProductSettingsTab({ firm, isOwnDealerFirm }) {
  return (
    <ProductSettingsTab
      firm={firm}
      readOnly={isOwnDealerFirm}
      dealerView
      useGetSyncHook={useLazyGetDealerRolesFirmSyncQuery}
      useUpdateSyncHook={useUpdateDealerRolesFirmSyncMutation}
    />
  );
}
